// extracted by mini-css-extract-plugin
export default {"notFound":"notfound_notFound__9W-9w"};